const route = [
    {//检查作业
        //type: 1-教师发布作业  2-学生书法练习
        path: '/qualityStation/taskDetail/:classid/:taskid',
        component: function (resolve) {
            require(['VIEWS/qualityStation/tea/check/taskDetail.vue'], resolve);
        }
    },
    {//文字作业预览
        path: '/qualityStation/preview/words/:taskid',
        component: function (resolve) {
            require(['VIEWS/qualityStation/tea/check/wordPreview.vue'], resolve);
        }
    },
    {//作业预览-知识点视频
        path: '/qualityStation/preview/video/:taskid',
        component: function (resolve) {
            require(['VIEWS/qualityStation/tea/check/videoPreview.vue'], resolve);
        }
    },
    {//作业预览-书法作品展示
        path: '/qualityStation/preview/task_require/:taskid',
        component: function (resolve) {
            require(['VIEWS/qualityStation/tea/check/taskRequirePreview.vue'], resolve);
        }
    },
]
export default route
